import React, { useCallback, useEffect, useMemo } from 'react'

import { Route, Switch } from 'react-router-dom'
import { batch, useDispatch, useSelector } from 'react-redux'

import SeafarersList from '../../components/SeafarersList/SeafarersList'
import SearchTabsPanel from '../../components/SearchTabsPanel/SearchTabsPanel'
import SeafarersSearchSort from '../../components/SeafarersSearchSort/SeafarersSearchSort'
import SeafarerCard from './SeafarerCard'
import SeafarersSearchPanel from '../../components/SeafarersSearchPanel/SeafarersSearchPanel'
import RequestFilterForm from '../../components/SeafarersSearchPanel/FilterForm/RequestFilterForm/RequestFilterForm'
import WithPreloader from '../../HOC/WithPreloader'

import {
  clearCommentsData,
  clearSeafarersRequestsList,
  resetFilterParams,
  setSeafarersRequestsList,
  updateRequestsFilter,
} from '../../redux/actions/seafarersSearch'
import { fetchSeafarersRequests } from '../../api/getApi'
import { fetchSeafarersHelper, objToQueryConverter } from '../../helpers/apiHelper'
import useInfiniteScroll from '../../hooks/useInfiniteScroll'
import { searchHelper } from '../../components/SeafarersSearchPanel/utils'
import { profilePaths } from '../../constants/constants'

const Requests = () => {
  // const [isFilterOpen, setIsFilterOpen] = useState(false)
  // const [isMouseUp, setIsMouseUp] = useState(false)

  const { vacancy_requests, requestFilter } = useSelector(({ seafarersSearch }) => seafarersSearch)

  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      batch(() => {
        dispatch(clearCommentsData())
        dispatch(clearSeafarersRequestsList())
        dispatch(resetFilterParams())
      })
    }

    // eslint-disable-next-line
  }, [])

  const values = useMemo(() => {
    return searchHelper(requestFilter)
  }, [requestFilter])

  const { loading, nextPage, handleScroll } = useInfiniteScroll(
    fetchSeafarersRequests,
    setSeafarersRequestsList,
    fetchSeafarersHelper,
    objToQueryConverter(values),
    clearSeafarersRequestsList
  )

  const handleListScroll = (e) => {
    handleScroll(e)

    // if (isMouseUp && event.target.scrollTop <= 90) {
    //   setIsFilterOpen(true)
    // } else {
    //   setIsFilterOpen(false)
    // }
  }

  const handleSortChange = useCallback((value, status) => {
    if (!value) return

    const separator = (() => {
      if (status) return ''

      return '-'
    })()

    const ordering = `${separator}${value}`

    dispatch(updateRequestsFilter({ ordering }))

    // eslint-disable-next-line
  }, [])

  return (
    <>
      <SeafarersSearchPanel Form={RequestFilterForm} searchValues={requestFilter} updateAction={updateRequestsFilter} />

      <div className="space-between min-height-50">
        <SearchTabsPanel route={profilePaths.seafarers_request} />

        <div style={{ padding: '0', width: '100%', maxWidth: '260px', alignSelf: 'flex-end' }}>
          <SeafarersSearchSort onChange={handleSortChange} />
        </div>
      </div>

      <Switch>
        <Route exact path={profilePaths.seafarers_request}>
          <WithPreloader
            size={150}
            type="magnifier"
            noContentMessage="Sorry, you don't have any requests."
            tab="requests"
            list={vacancy_requests}
            component={SeafarersList}
            isLoading={nextPage ? loading : null}
            isActive={nextPage === 1 && loading}
            onScroll={handleListScroll}
            // onWheel={(e) => (e.deltaY > 0 ? setIsMouseUp(false) : setIsMouseUp(true))}
            // anotherControlRender={(args, id) => (
            //   <Tooltip arrow={true} direction="up" arrowSize={7} content="Reject" padding={8}>
            //     <button
            //       disabled={request}
            //       onClick={(event) => handleDeleteClick(event, id)}
            //       style={{ color: '#C20000' }}
            //       {...args}
            //     >
            //       <CrossSvg stroke="#C20000" />
            //     </button>
            //   </Tooltip>
            // )}
          />
        </Route>

        <Route exact path={`${profilePaths.seafarers_request}/:id`} component={SeafarerCard} />
      </Switch>
    </>
  )
}

export default Requests
